import React, {useEffect, useState} from 'react';
import {useScrollPosition} from '@n8tb1t/use-scroll-position';
import classNames from "classnames";
import {useBreakpoint} from "../../../libs/breakpoint";
import {tools} from "../../../libs/api";
import {useLocation, withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import _ from "lodash";
import {connect} from "react-redux";
//import fakeThumb from "./images/thumb.jpg";


//const frameUrl = "https://www.voissa.cam/prm/livewebcam/?cf=ffffff&cc=ffffff&ct=ffffff&zoom_lvl=0&cat=2,3,4,5,6,7,9,10,11,12,13&psm=KendraTom&trac= instant-cam";
//const linkHref = "https://voissa.cam/fr/model/hotcoupleanal/?&tdxx=IgbrJ28YdjilXGtmavcDaMYDPhwcvzSq1rOe25OXTDa6yonthxHQ2FS%2Fy8nUsF0IYMcpHokcEVR3YRQr2qFYh8aoG5Vyn4gZ4Za4M0tmo%2FKvZAOThbT87Ff5v1V8UYSq%2FVzym2zBqu014DEEtVjB5WFEPnAakoFQQgN35Sk3FzQ%3D&idpt=32&idspt=13590444278&sizeList=medium";
const securityScrollMargin = 40;

const MobileLiveTool = () => {
    let [toggle, setToggle] = useState(false);
    const [toolData, setToolData] = useState({status: 0});
    let location = useLocation();

    useScrollPosition(({prevPos, currPos}) => {
        const positiveCurrPosY = Math.abs(currPos.y);
        const isShow = (positiveCurrPosY > securityScrollMargin && positiveCurrPosY < ((document.documentElement.scrollHeight - document.documentElement.clientHeight) - securityScrollMargin));
        if (isShow !== toggle) setToggle(isShow);
    }, [toggle]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await tools.getLiveBottom({page:location.pathname});
                setToolData(result);
            }
            catch (e){}
        }
        fetchData();
    }, [location]);
    //console.log(toolData);
    return toolData && toolData.status ? (
        <a href={toolData.link} target={"_blank"} rel="noopener noreferrer" className={classNames("MobileLiveTool", {hidden: !toggle})}>
            <div className="frame-wrapper">
                {/*<iframe
                    title="cam"
                    src={toolData.camFrameUrl}
                    scrolling="no" frameBorder="0"/>*/}
                <img src={"https://tools.emstat.fr/voissa/100x100.png"} alt={"Jade"}/>
            </div>
            <div className="live-infos-wrapper">
                <div className="live-name">
                    Je suis en ligne
                </div>
                <div className="live-cta">Envoyez-moi un message !</div>
            </div>
        </a>
    ) : null
}

const MobileLiveToolWrapper = (props) => {
    const breakpoints = useBreakpoint();
    let isChrome = RegExp(/Chrome\/[0-9.]+ (?:Mobile )?Safari\/[0-9.]+$|CriOS|Googlebot/).test(window.navigator.userAgent);

    return breakpoints.md && _.get(props.isTool,"status") && !(isChrome && (document.querySelector('html.translated-ltr'))) ? <MobileLiveTool/> : null;
}

const mapStateToProps = (state) => {
    return {
        isTool: state.isTool.data,
        isToolInitialized: state.isTool.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobileLiveToolWrapper));
